import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-admin-client-property-dialog',
  templateUrl: './admin-hp-property-dialog.component.html',
  styleUrls: ['./admin-hp-property-dialog.component.css']
})
export class AdminHpPropertyDialogComponent implements OnInit {
  form!: FormGroup;
  title: string;
  date: string;
  isAvailable?: boolean;
  ownerName?: string;
  managerName?: string;
  contactPhone?: string;
  email? : string;
  address?: string;
  city?: string;
  zipCode?: string;
  buildingNumber?: string;
  buildingUnits?: number;
  availableUnits?: number;
  propertyNote?: string;
  hcvCheck?: boolean;
  hcvNote?: string;
  cuCheck: any;
  cuUnits: any;
  cuProvider: any;
  cuNote: any;
  lsCheck: any;
  lsProvider: any;
  lsUnits: any;
  lsNote: any;
  latitude: any;
  longitude: any;
  buildingAdaAccessible?: boolean;
  unitAdaAccessible?: boolean;
  accessibleNote?: string;
  incentiveForRentwise?: boolean;
  incentiveNote?: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AdminHpPropertyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data:any) {
      // Dynamic title for Add or Edit Property
      this.title = data.title;

      // If adding new property, use current date, if editing existing property then use original entry date
      if (!data.entryDate) {
        this.date = formatDate(Date.now(), 'shortDate', 'en-US');
      } else {
        this.date = data.entryDate;
      }

      this.isAvailable = data.isAvailable;
      this.ownerName = data.ownerName;
      this.managerName = data.managerName;
      this.contactPhone = data.contactPhone;
      this.email = data.email;
      this.address = data.address;
      this.city = data.city;
      this.zipCode = data.zipCode;
      this.buildingNumber = data.buildingNumber;
      this.buildingUnits = data.buildingUnits;
      this.availableUnits = data.availableUnits;
      this.propertyNote = data.propertyNote;
      this.hcvCheck = data.hcvCheck;
      this.hcvNote = data.hcvNote;
      this.buildingAdaAccessible = data.buildingAdaAccessible;
      this.unitAdaAccessible = data.unitAdaAccessible;
      this.accessibleNote = data.accessibleNote;
      this.incentiveForRentwise = data.incentiveForRentwise;
      this.incentiveNote = data.incentiveNote;

      // Admin only fields, passed so landlords don't erase it by editting their properties
      this.cuCheck = data.cuCheck;
      this.cuUnits = data.cuUnits;
      this.cuProvider = data.cuProvider;
      this.cuNote = data.cuNote;
      this.lsCheck = data.lsCheck;
      this.lsProvider = data.lsProvider;
      this.lsUnits = data.lsUnits;
      this.lsNote = data.lsNote;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
    }

  ngOnInit() {
    this.form = this.fb.group({
      entryDate: [this.date, []],
      isAvailable: [this.isAvailable, []],
      ownerName: [this.ownerName, []],
      managerName: [this.managerName, []],
      contactPhone: [this.contactPhone, []],
      email: [this.email, []],
      address: [this.address, []],
      city: [this.city, []],
      zipCode: [this.zipCode, []],
      buildingNumber: [this.buildingNumber, []],
      buildingUnits: [this.buildingUnits, []],
      availableUnits: [this.availableUnits, []],
      propertyNote: [this.propertyNote, []],
      hcvCheck: [this.hcvCheck, []],
      hcvNote: [this.hcvNote, []],
      cuCheck: [this.cuCheck, []],
      cuUnits: [this.cuUnits, []],
      cuProvider: [this.cuProvider, []],
      cuNote: [this.cuNote, []],
      lsCheck: [this.lsCheck, []],
      lsProvider: [this.lsProvider, []],
      lsUnits: [this.lsUnits, []],
      lsNote: [this.lsNote, []],
      latitude: [this.latitude, []],
      longitude: [this.longitude, []],
      buildingAdaAccessible: [this.buildingAdaAccessible, []],
      unitAdaAccessible: [this.unitAdaAccessible, []],
      accessibleNote: [this.accessibleNote, []],
      incentiveForRentwise: [this.incentiveForRentwise, []],
      incentiveNote: [this.incentiveNote, []],
    });
  }

  save() {
      this.dialogRef.close(this.form.value);
  }

  close() {
      this.dialogRef.close();
  }

}
